module.exports = __webpack_public_path__ + "img/CM-SL-CA-Subaru-Playful.ac4f7511.jpg";